

















































































import Vue from 'vue'
import ActiveHomeDashboardToolbar from '@/components/ActiveHomeDashboardToolbar.vue'
import HomePhoneNumber from '@/components/HomePhoneNumber.vue'
import ActiveDashboardAnalytics from '@/components/ActiveHomeDashboardAnalytics.vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: { ActiveHomeDashboardToolbar, HomePhoneNumber, ActiveDashboardAnalytics },
    data: () => ({
        loading: false
    }),
    async mounted() {
        //  Check if we have metrics already
        const metrics = this.tenantMetrics

        //  If already set, don't refresh
        if (metrics) return

        //  Start loading
        this.loading = true

        //  Get our metrics
        if (!this.tenantMetrics) await this.$store.dispatch('tenantMetrics')

        //  Stop loading
        this.loading = false
    },
    computed: {
        ...mapGetters([
            'isApp',
            'plan',
            'smsAccount',
            'subscription',
            'tenant',
            'tenantMetrics',
            'trialing',
            'user',
        ]),
        homeTiles() {
            //  Grab all of our metric values
            const msgs = this.tenantMetrics?.newMessages || 0
            const unrNot = this.tenantMetrics?.unreadNotifs || 0
            const unrCom = this.tenantMetrics?.unreadComments || 0

            return [
                {
                    title: 'My Inbox',
                    columns: [
                        {
                            value: msgs,
                            display: 'My New Messages',
                            btn: {
                                text: 'View',
                                icon: 'bi-arrow-right-circle-fill',
                                callback: () =>
                                    this.$router.push(`/inbox?assigned=${this.user.id}`)
                            }
                        },
                        {
                            value: unrNot,
                            display: 'Unread Notifications',
                            btn: {
                                text: 'View',
                                icon: 'bi-arrow-right-circle-fill',
                                callback: () => this.$router.push('/notifications')
                            }
                        },
                        {
                            value: unrCom,
                            display: 'Unread Comments',
                            btn: {
                                text: 'View',
                                icon: 'bi-arrow-right-circle-fill',
                                callback: () =>
                                    this.$router.push('/notifications?type=mention')
                            }
                        }
                    ]
                }
            ]
        },
        maxCredits(): number {
            // If they aren't on a plan, no credits given
            if (!this.plan?.metadata) return 0

            //  If they are trialing, return 50
            if (this.trialing) return 50

            // Store the user's metadata from their plan
            const meta = this.plan.metadata

            // If they have no message allowance on their plan nor do they have credits on a trial plan, no credits given
            if (!meta.message_allowance && !meta.trial_message_allowance) return 0

            // Otherwise get the amount of credits they're allowed to use from one of their plans, either trialing or payment
            const amt =
                parseInt(meta.message_allowance) || parseInt(meta.trial_message_allowance)

            // Return the amount of credits given or 0 in case of edge case
            return amt || 0
        },
        renewalDate(): Date | string {
            //  If our sub doesn't exist, return null
            if (!this.subscription) return null

            //  Else, grab our period end
            return this.subscription.current_period_end
        },
        widthStyle(): string {
            //  Grab our breakpoint
            const bp = this.$vuetify.breakpoint.name

            //  Depending on our current breakpoint we have a different style for width
            const style =
                {
                    sm: 'width: 600px;',
                    md: 'width: 800px;',
                    lg: 'width: 800px;',
                    xl: 'width: 800px;'
                }[bp] || ''

            //  Return our style
            return style
        }
    }
})
